<template>
  <div class="wrap" id="boxFixed">
    <!-- v-show="isFixed" -->
    <div class="header_fixed">
      <headTop :background="background"></headTop>
    </div>
    <div class="role">
      <div class="header">
        <div class="wrap_header">
          <div class="wrap_header_content header-wrapper-content">
            <div class="wrap_header_content_left">
              <div
                class="wrap_header_content_left_box"
                :style="{ borderBottom: idx > 4 ? 0 : '' }"
                v-for="(item, idx) in leftLeft"
                :key="idx"
                @click="goToSpecialistCenter(item.name, item.id)"
              >
                <img
                  class="wrap_header_content_left_box_img"
                  :src="$store.getters.imgUrl + item.logo"
                  alt
                />
                <span class="wrap_header_content_left_box_text">{{
                  item.name
                }}</span>
                <div class="box-wrap">
                  <span class="headerInfo">{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div class="header-img-wrapper">
              <!-- <img
                class="wrap_header_content_img"
                src="@/assets/image/index/rightImg.png"
                alt
              /> -->
              <div class="header-img-wrapper-top">
                <img
                  v-if="!$store.getters.userInfo.avatar"
                  class="wrap_header_content_img"
                  src="@/assets/image/index/home-avatar.png"
                  alt
                />
                <img
                  v-else
                  class="wrap_header_content_img avatar"
                  :src="$store.getters.imgUrl + $store.getters.userInfo.avatar"
                  alt
                />
                <div v-if="!$store.getters.token" class="signIn-signUp">
                  <div class="signIn" style="cursor: pointer" @click="login">
                    登录
                  </div>
                  <div class="spacer">|</div>
                  <div class="signUp" style="cursor: pointer" @click="register">
                    注册
                  </div>
                </div>

                <div v-if="$store.getters.token" class="userInfo">
                  <div class="userInfo-userName">
                    <span @click.stop="$store.commit('editPwd', 2)" style="cursor: pointer">{{
                      $store.getters.userInfo.nickName
                    }}</span>
                  </div>
                  <div class="userInfo-control-panel">
                    <span @click.stop="$store.commit('editPwd', 1)" style="cursor: pointer"
                      >修改密码</span
                    >
                    <div class="spacer">|</div>
                    <span @click="signOut" style="cursor: pointer">退出</span>
                  </div>
                </div>
                <div class="header-img-wrapper-top-content">
                  <div class="header-img-wrapper-top-content-text">
                    青岛环境医院环保产业
                  </div>
                  <div class="header-img-wrapper-top-content-text">
                    信息化服务平台
                  </div>
                </div>
              </div>
              <div class="header-img-wrapper-bottom">
                <div class="header-img-wrapper-bottom-time">
                  <div class="header-img-wrapper-bottom-time-text">
                    问诊时间：9:00-17:30
                  </div>
                  <div class="header-img-wrapper-bottom-time-remark">
                    (周末及法定节假期除外)
                  </div>
                </div>
                <!-- <div class="header-img-wrapper-bottom-contact">
                  <div class="header-img-wrapper-bottom-contact-text">
                    服务热线:
                  </div>
                  <div class="header-img-wrapper-bottom-contact-number">
                    (0532)82899922
                  </div>
                </div> -->
                <div class="onlineConsultation">
                  <!-- wrap_header_content_btn -->
                  <button
                    class="onlineConsultation-btn"
                    @click="goToConsultation(0)"
                  >
                    在线问诊
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap_content" style="margin-top: 0.8em">
        <div class="wrap_content_fore">
          <boxHead
            :headObj="{
              title: '产品与服务',
              titleEng: 'PRODUCTS AND SERVICES',
            }"
          ></boxHead>
          <ul class="listBox">
            <li
              v-for="item in indexObj.productList"
              :key="item.id"
              @click="goToDetail(item.id)"
            >
              <!-- <div class="jsTop">优质推荐</div> -->
              <img
                :src="$store.getters.imgUrl + item.logo"
                alt
                v-if="item.logo"
              />
              <!-- <img src="@/assets/image/equipment/3.png" alt="" v-if="!item.logo" > -->
              <div class="NoLogoBox" v-if="!item.logo">
                <span>{{ item.name }}</span>
              </div>
              <span class="company">{{ item.enterpriseName }}</span>
              <span class="title">{{ item.name }}</span>
              <!-- <span class="info">{{item.content}}</span> -->
              <!-- <div class="detail" >
                <span>详情</span>
                <img src="@/assets/image/index/moreO.png" alt />
              </div>-->
              <div class="buttonZX">详情</div>
            </li>
            <li
              v-show="indexObj.productList.length % 4 > 0"
              v-for="item in 4 - (indexObj.productList.length % 4)"
              :key="item"
              class="addLi"
              style="border: none"
            ></li>
          </ul>
        </div>
        <!-- 专家风采 -->
        <div class="wrap_content_three">
          <div class="wrap_content_three-inner">
            <boxHead
              :headObj="{ title: '专员风采', titleEng: 'EXPERT STYLE' }"
            ></boxHead>
            <div class="wrap_content_three_body">
              <div
                class="wrap_content_three_body_box"
                v-for="(item, index) in indexObj.expertList"
                :key="index"
                @click="goToSavant(item.id)"
                style="cursor: pointer"
              >
                <div class="wrap_content_three_body_box_head">
                  <img
                    class="wrap_content_three_body_box_head_imgStart"
                    src="@/assets/image/index/start.png"
                    alt
                  />
                  <div
                    class="imgBox"
                    :style="{
                      'background-image': `url(${
                        $store.getters.imgUrl + item.avatar
                      })`,
                    }"
                  ></div>

                  <div class="wrap_content_three_body_box_head_right">
                    <h3>{{ item.name }}</h3>
                    <h6>{{ item.officeNameStr }}</h6>
                  </div>
                </div>
                <div class="wrap_content_three_body_box_content">
                  <span>个人简介：</span>
                  {{ item.introduceContent }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 云课堂 -->
        <div class="boxBg" style="margin-bottom: 0.8em">
          <div class="wrap_content_fore wrap_content_cloud">
            <boxHead
              :headObj="{ title: '云课堂', titleEng: 'CLOUD CLASSROOM' }"
            ></boxHead>
            <div class="wrap_content_fore_body">
              <div
                class="wrap_content_fore_body_box"
                v-for="item in indexObj.cloudClassList"
                :key="item.createTime"
              >
                <a :href="item.fileUrl" target="_blank">
                  <img
                    class="wrap_content_fore_body_box_img"
                    :src="item.logo ? $store.getters.imgUrl + item.logo : ''"
                    alt
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部组件 -->
      <footCode></footCode>
      <!-- 回顶部 -->
      <img
        v-if="isFixed"
        class="backTo"
        src="@/assets/image/index/backTop.png"
        @click="backToTop"
      />
    </div>
  </div>
</template>
<script>
import footCode from "@/components/footCode";
import boxHead from "@/components/boxHead";
import headTop from "../../components/HeadTop";
export default {
  name: "index",
  components: {
    footCode,
    boxHead,
    headTop,
  },
  data() {
    return {
      loading: true,
      indexObj: {
        // 首页接口数据
        officeList: [], // 科室列表
        cloudClassList: [], // 云课堂列表
        productList: [],
        expertList: [], //专家风采
      },
      background: "rgba(0,0,0,0)",
      list: [],
      leftLeft: [],
      oneTopList: ["技术装备", "优秀案例"],
      idxActive: 0, // 技术设备选中
      isFixed: false, // 是否固定到顶部
      mode: {
        page: 1,
        limit: 12,
      },
      scrollTop: "",
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll, true);
    this.indexInit();
    this.getNumList();
  },
  methods: {
    //访问量接口无需关心
    getNumList() {
      this.ajaxUtil({
        method: "post",
        url: this.$store.state.axiosUrl + "/api/home/v2/visit",
      }).then((res) => {});
    },
    goToequipment() {
      if (this.idxActive == 0) {
        this.$router.push({
          path: "/equipment",
        });
      } else {
        this.$router.push({
          path: "/case",
        });
      }
    },
    goToDetail(id) {
      this.$router.push({
        path: "/case/caseDetail",
        query: {
          id: id,
          index: 2,
        },
      });
    },
    goToSavant(id) {
      this.$router.push({
        path: "/savant/detail",
        query: {
          id,
        },
      });
    },
    goToConsultation(pid) {
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error("请先登录");
        return false;
      } else {
        this.$store.commit("changechatShow", true);
        this.$store.commit("changePid", pid);
      }
    },
    indexInit() {
      // 首页接口
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/home/v2/index",
      }).then((response) => {
        this.leftLeft = response.data.officeList.splice(0, 10);
        this.indexObj = response.data;
      });
    },
    handleScroll() {
      // 监听滚动事件
      let scrollTop = document.getElementsByClassName("role")[0].scrollTop;
      // let offsetTop = document.getElementsByClassName("role")[0]
      //     .offsetHeight; // 要滚动到顶部吸附的元素的偏移量
      this.isFixed = scrollTop > 50 ? true : false; // 如果滚动到顶部了，this.isFixed就为true
      this.background = scrollTop > 50 ? "#2579bf" : "rgba(0,0,0,0)";
      // console.log(scrollTop , offsetTop, this.isFixed)
    },
    backToTop() {
      // 置顶
      document.getElementsByClassName("role")[0].scrollTo(0, 0);
    },
    //跳转专科中心
    goToSpecialistCenter(name, id) {
      this.$router.push({
        path: "/specialistCenter",
        query: { name, id },
      });
    },
    login() {
      this.$store.commit("changeDialog", true);
      this.$store.commit("changeToggle", 1);
    },
    register() {
      this.$store.commit("changeDialog", true);
      this.$store.commit("changeToggle", 2);
    },
    signOut() {
      // 退出
      this.$confirm("是否确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$store.dispatch("getToken", "");
          this.$store.dispatch("getUserInfo", "");
          this.$store.dispatch("getUserDeptInfo", "");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userInfo");
          sessionStorage.removeItem("userDeptInfo");
          sessionStorage.removeItem("publcKey");

          this.$message({
            type: "success",
            message: "退出成功",
          });
        })
        .catch(() => {});
    },
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll, true);
  },
  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.getElementsByClassName("role")[0].scrollTop;
    this.$store.commit("changeScrollTop", this.scrollTop);
    console.log(this.scrollTop);
    next();
  },
  activated() {
    this.$nextTick(() => {
      //恢复滚动高度
      console.log(this.$store.state.scrollTop);
      document
        .getElementsByClassName("role")[0]
        .scrollTo(0, this.$store.state.scrollTop);
    });
  },
};
</script>
<style scoped lang="less">
@import url("~@/assets/css/index.less");
.jsTop {
  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  font-size: 0.13em;
  padding: 8px 15px;
}
.wrap_content_three-inner {
  width: 12.8em;
  margin: auto;
}
.imgBox {
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background-size: cover;
  margin-right: 10px;
}
.box-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.listBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  li {
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 24%;
    margin-top: 20px;
    // height: 2.8em;
    cursor: pointer;
    .title {
      color: #2579bf;
      font-size: 0.15em;
      font-weight: 600;
      padding: 10px;
      height: 54px;
      line-height: 23px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    img {
      height: 1.7em;
      width: 100%;
    }
    span {
      font-size: 0.15em;
      padding: 5px 10px;
    }
    .company {
      position: absolute;
      top: 9.3em;
      left: 0;
      width: 100%;
      white-space: nowrap;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
    }
    .info {
      padding: 5px 10px;
      padding-bottom: 80px;
      overflow: hidden;
      font-size: 0.15em;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      color: #555;
    }
  }
}
.buttonZX {
  text-align: center;
  padding: 10px;
  margin-top: 10px;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  // position: absolute;
  font-weight: 600;
  width: 100%;
  // bottom: 0;
}
.NoLogoBox {
  background-image: url("~@/assets/image/equipment/3.png");
  background-size: cover;
  height: 1.7em;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: hzgb;
  align-items: center;
  text-align: -webkit-center;
  span {
    margin-top: -20px;
    font-size: 13px !important;
    font-weight: 600;
    letter-spacing: 3px;
  }
}
.headerInfo {
  font-size: 0.15em;
  padding: 0 10px 10px 10px;
  color: rgba(232, 232, 232, 1);
  margin-top: 10px;
  width: 100%;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  /*设置行高和总体文本高度防止文字在显示时被截取了半行*/
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 3; /*表示最终显示的行数*/
  // /* autoprefixer: off */
  // -webkit-box-orient: vertical;
  // /* autoprefixer: on */
}
.header-img-wrapper {
  width: 3em;
  // background-image: url("~@/assets/image/index/rightImg.png");
  background: #ffffff;
  opacity: 0.95;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0.58em 0.39em 0.32em 0.39em;
  display: flex;
  flex-direction: column;
  align-items: center;
  .avatar {
    border-radius: 100%;
    border: 1px solid grey;
  }
  .header-img-wrapper-top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .wrap_header_content_img {
      width: 1.12em;
      height: 1.12em;
      margin-bottom: 0.14em;
    }
    .signIn-signUp {
      width: 0.91rem;
      display: flex;
      font-size: 0.18em;
      color: #2579bf;
      justify-content: space-between;
      align-items: center;
      margin: auto;
    }
    .userInfo {
      // width: 0.91rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      font-size: 0.18em;
      color: #2579bf;
      justify-content: space-between;
      align-items: center;
      &-userName {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        text-align: center;
      }
      &-control-panel {
        width: 1.3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.15rem;
      }
    }
    .header-img-wrapper-top-content {
      text-align: center;
      margin-top: 0.37rem;
      &-text {
        font-size: 0.18rem;
        line-height: 0.26rem;
      }
    }
  }
  .header-img-wrapper-bottom {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.92rem;
    &-time {
      text-align: center;
      &-text {
        font-size: 0.18rem;
        color: #333333;
        line-height: 0.26rem;
      }
      &-remark {
        font-size: 0.16rem;
        color: #333333;
        line-height: 0.26rem;
        margin-top: 0.05rem;
      }
    }
    &-contact {
      margin-top: 0.25rem;
      &-text {
        font-size: 0.18rem;
        color: #333333;
        line-height: 0.26rem;
      }
      &-number {
        margin-top: 0.05rem;
        font-size: 0.18rem;
        color: #333333;
        line-height: 0.26rem;
      }
    }
    .onlineConsultation {
      width: 100%;
      text-align: center;
      &-btn {
        //  width: 1.3rem;
        //  height: 0.4rem;
        font-size: 0.18rem;
        padding: 0.11rem 0.23rem 0.11rem 0.23rem;
        font-weight: bold;
        color: #ffffff;
        background: linear-gradient(0deg, #3ec5d1 0%, #2786d0 100%);
        border-radius: 5px;
        animation: myFrame1 2s linear infinite;
        -webkit-animation: myFrame1 2s linear infinite;
        cursor: pointer;
      }
    }
  }
}
// 在线咨询动画
@keyframes myFrame1 {
  10% {
    padding: 0.12rem 0.24rem 0.12rem 0.24rem;
  }
  20% {
    padding: 0.13rem 0.25rem 0.13rem 0.25rem;
  }
  30% {
    padding: 0.14rem 0.26rem 0.14rem 0.26rem;
  }
  40% {
    padding: 0.15rem 0.27rem 0.15rem 0.27rem;
  }
  50% {
    padding: 0.16rem 0.28rem 0.16rem 0.28rem;
  }
  60% {
    padding: 0.15rem 0.27rem 0.15rem 0.27rem;
  }
  70% {
    padding: 0.14rem 0.26rem 0.14rem 0.26rem;
  }
  80% {
    padding: 0.13rem 0.25rem 0.13rem 0.25rem;
  }
  90% {
    padding: 0.12rem 0.24rem 0.12rem 0.24rem;
  }
}
// 改动了INDEX.CSS内类的样式
.header-wrapper-content {
  height: 100%;
}

.wrap_header_content_left_box_text {
  width: 100%;
  text-align: center;
  word-wrap: break-word; /*强制换行*/
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  white-space: nowrap; /*强制不换行*/
}
// 让主页标题下蓝色下划线宽度等于标题
/deep/.wrap_content_fore .boxBg_head .boxBg_head_line {
  width: 1.3em !important;
  height: 4px;
  position: absolute;
  left: 0;
  bottom: -2px;
  background: @colorOne;
}
/deep/.wrap_content_three .boxBg_head .boxBg_head_line {
  width: 1.04em !important;
  height: 4px;
  position: absolute;
  left: 0;
  bottom: -2px;
  background: @colorOne;
}
/deep/.wrap_content_cloud .boxBg_head .boxBg_head_line {
  width: 0.78em !important;
  height: 4px;
  position: absolute;
  left: 0;
  bottom: -2px;
  background: @colorOne;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue